export default {
  methods: {
    moneyformat(value, precision = 2) {
      return value !== null
        ? parseFloat(value)
            .toLocaleString('lt', {
              style: 'currency',
              currency: 'EUR',
              useGrouping: true,
            })
            .split('€')[0]
            .replace('.', ',')
        : '0,00'
    },
    floatformat(value, precision = 2) {
      const nulis = '0'
      return value !== null
        ? parseFloat(value)
            .toFixed(precision)
            .toString()
            .replace('.', ',')
        : '0,' + nulis.repeat(precision)
    },
    noSpecialChar(name) {
      return name ? name.replaceAll(/(\\|\/|:|\*|\?|"|\<|\>|\|)+/g, '-') : ''
    },
    noDiacritic(name) {
      return name ? name.normalize('NFD').replace(/\p{Diacritic}/gu, '') : ''
    },
    safeFileName(name) {
      if (!name) {
        return ''
      }
      name = this.noSpecialChar(name)
      name = this.noDiacritic(name)
      return name
    },
    signFileName(name) {
      return this.safeFileName(name)
    },
    splitDate(date) {
      let diena = null
      let laikas = null
      if (date) {
        const dateMas = date.toString().split(' ')
        diena = dateMas[0]
        if (dateMas.length > 1) {
          laikas = dateMas[1]
        }
      }
      return {
        diena,
        laikas,
      }
    },
  },
}
